import React from "react"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import TurtleSVG from "../../static/svgs/backToTop"

type Props = {
  threshold?: number
  isShown?: boolean
  isSmart?: boolean
}

const BackToTop = ({
  threshold = 1000,
  isShown = true,
  isSmart = true,
}: Props) => {
  const [isButtonVisible, setIsButtonVisible] = React.useState(false)
  const { width } = useWindowDimensions()

  React.useEffect(() => {
    window.addEventListener("scroll", () => {
      setIsButtonVisible(window.scrollY > threshold)
    })
  }, [])

  const goToTop = () => {
    if (!isButtonVisible) {
      return
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }

  if (width && width < 784) {
    return null
  }

  return (
    <img
      className={`fixed right-10 bottom-11 lg:bottom-6 ${
        isSmart ? "xl:right-72 2xl:right-10 xl:bottom-11" : ""
      } transition-opacity ease-in-out hover:-translate-y-2 ${
        isButtonVisible && isShown ? "opacity-100 cursor-pointer" : "opacity-0"
      }`}
      alt="back-to-top-turtle"
      src={TurtleSVG}
      onClick={goToTop}
      style={{
        filter:
          "drop-shadow(-10px -10px 30px rgba(0, 0, 0, 0.25))",
      }}
    />
  )
}

export default BackToTop
